import { createFileRoute } from '@tanstack/react-router'
import { LearnCentrePage } from '@/features/learn-centre'

export const Route = createFileRoute('/_auth/learn-centre')({
  component: LearnCentrePage,
})
